import dayjs from '../utils/dayjsConfig'

export const PROMO_CLIENT_TYPE = 'client'
export const PROMO_QUALIFIER_TYPE = 'qualifier'
export const API_KEY =
  process.env.REACT_APP_GOOGLE_MAP_KEY || 'AIzaSyAxo7saU4Ewn8PSMh8Nk4Y_m5vvC1LbrAQ'
export const DEFAULT_PER_PAGE = 25
export const REFUND_STATUS = [
  { name: 'ENVIADO', value: 'sent' },
  { name: 'RECIBIDO', value: 'received' }
]
export const SPINNER_SIZE = 40
export const SPINNER_COLOR = '#597FA9'

export const DATE_PICKER_SETTINGS = {
  months: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
  weekDays: ['D','L','M','M','J','V','S'],
  weekStartDayIndex: 1,
  maxDate: () => dayjs().local().endOf('day').toDate()
}
